import { render, staticRenderFns } from "./dhPatientCard.vue?vue&type=template&id=6988a94c&"
import script from "./dhPatientCard.vue?vue&type=script&lang=js&"
export * from "./dhPatientCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports